import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthCheck } from './lib/auth.ts';
import { Dashboard } from './pages/Dashboard.tsx';
import { PivotPage } from './pages/Pivot.tsx';
import { AdminPage } from './pages/Admin.tsx';
import { ReportsPage } from './pages/Reports.tsx';
import { PeriodenvergleichPage } from './pages/Periodenvergleich.tsx';
import { TopNReportPage } from './pages/TopNReport.tsx';
import { StornoReportPage } from './pages/StornoReport.tsx';
import { BenchmarkPage } from './pages/Benchmark.tsx';
import { AktivitaetPage } from './pages/Aktivitaet.tsx';
import { WgTagesumsatzPage } from './pages/WgTagesumsatz.tsx';
import { ArtikelReportPage } from './pages/ArtikelReport.tsx';
import { UmsatzReportPage } from './pages/UmsatzReport.tsx';
import { HeatmapReportPage } from './pages/HeatmapReport.tsx';
import { WgTrendReportPage } from './pages/WgTrendReport.tsx';
import { AppShell } from './components/AppShell.tsx';

export default function App() {
  const auth = useAuthCheck();

  if (auth.isLoading) {
    return (
      <div className="h-full flex items-center justify-center text-slate-500">
        Lade …
      </div>
    );
  }

  if (!auth.authenticated) {
    return (
      <div className="h-full flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-8">
        <div className="card card-body max-w-lg w-full text-center">
          <h1 className="text-xl font-semibold mb-2">Statistik-Modul</h1>
          {!auth.backendReachable ? (
            <>
              <p className="text-red-600">Backend nicht erreichbar.</p>
              {auth.error && (
                <p className="text-xs text-slate-500 mt-2">{auth.error}</p>
              )}
            </>
          ) : (
            <>
              <p className="text-slate-700 dark:text-slate-300 mb-4">
                Du bist nicht im DRS-Cockpit eingeloggt.
              </p>
              <a href="/" className="btn-primary inline-block">
                Zum Cockpit-Login
              </a>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <AppShell user={auth.user!}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/pivot" element={<PivotPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/reports/topn" element={<TopNReportPage />} />
        <Route path="/reports/stornos" element={<StornoReportPage />} />
        <Route path="/reports/benchmark" element={<BenchmarkPage />} />
        <Route path="/reports/aktivitaet" element={<AktivitaetPage />} />
        <Route path="/reports/wg-tagesumsatz" element={<WgTagesumsatzPage />} />
        <Route path="/reports/artikel" element={<ArtikelReportPage />} />
        <Route path="/reports/umsatz" element={<UmsatzReportPage />} />
        <Route path="/reports/heatmap" element={<HeatmapReportPage />} />
        <Route path="/reports/wg-trend" element={<WgTrendReportPage />} />
        <Route path="/periodenvergleich" element={<PeriodenvergleichPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
